import React from "react";
import { Modal } from "react-bootstrap";
import { isEmpty, get } from "lodash";
import withBranding from "@irati/brand/withBranding";
import Expand from "@irati/ui/src/Expander";
import { Label1 } from "@irati/ui/src/Labels";
import "./styled/styles.css";
import { determineDealThumbnailImage } from "@irati/deals/helpers/deals/appearance";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import { getVouchersFromRedemption } from "../../helpers/redemption/getVouchersFromRedemption";
import TicketRepeater from "../Tickets/TicketRepeater";
import BirthdayBoxTicket from "../Tickets/Ticket/BirthdayBoxTicket";
import TicketInstructions from "../Tickets/TicketInstructions";
import Terms from "../Tickets/Terms";
import TicketTop from "../Tickets/TicketTop";
import TicketBottom from "../Tickets/TicketBottom";
import DownloadPdf from "../Tickets/DownloadPdf";
import { DealAvatar, InstructionHeader, PopupHeader, StyledClose } from "./styled/PerkSummaryPopup";
var PerkSummaryPopup = function (_a) {
    var _b;
    var redemption = _a.redemption, show = _a.show, onHide = _a.onHide, formatMessage = _a.formatMessage, branding = _a.branding;
    var _c = redemption.deal, header = _c.header, redemptionInstructions = _c.redemptionInstructions;
    var isBirthdayBox = (_b = redemption === null || redemption === void 0 ? void 0 : redemption.fullDeal) === null || _b === void 0 ? void 0 : _b.isBirthdayBox;
    var vouchers = get(redemption, "order", null) ? getVouchersFromRedemption(redemption) : [];
    var pdf = get(redemption, "pdf");
    var thumbnailImage = determineDealThumbnailImage(redemption.deal, branding);
    return (React.createElement(Modal, { show: show, onHide: onHide, dialogClassName: "myPerksTicket-dialog" },
        React.createElement(StyledClose, { top: "20px", right: "20px", onClick: onHide }),
        React.createElement(TicketTop, null,
            React.createElement("div", { className: "center" },
                React.createElement(DealAvatar, { src: thumbnailImage, alt: header, marginTop: -20, large: true, withShadow: true }),
                React.createElement(PopupHeader, null, header),
                React.createElement(InstructionHeader, null,
                    React.createElement(FormattedMessage, { id: "perks.components.myPerks.perkSummaryPopup.upperText" }),
                    React.createElement("br", null),
                    React.createElement(FormattedMessage, { id: "perks.components.myPerks.perkSummaryPopup.lowerText" }))),
            !isEmpty(vouchers) && (React.createElement("div", { className: "center" },
                React.createElement(Expand, { hideText: formatMessage({ id: "perks.components.myPerks.perkSummaryPopup.expand.hide" }), showText: formatMessage({ id: "perks.components.myPerks.perkSummaryPopup.expand.show" }), HeaderLabel: Label1 },
                    React.createElement(TicketInstructions, { item: redemption.deal, instructions: redemptionInstructions })))),
            isEmpty(vouchers) && React.createElement(TicketInstructions, { item: redemption.deal, instructions: redemptionInstructions }),
            React.createElement(DownloadPdf, { pdf: pdf, className: "center" })),
        !isEmpty(vouchers) && isBirthdayBox && React.createElement(BirthdayBoxTicket, { vouchers: vouchers }),
        !isEmpty(vouchers) && !isBirthdayBox && React.createElement(TicketRepeater, { redemptionId: redemption.uuid, vouchers: vouchers }),
        React.createElement(TicketBottom, null,
            React.createElement(Terms, null))));
};
export default injectIntl(withBranding(PerkSummaryPopup));
